export enum PermissionTypes {
  SET_PERMISSION = "SET_PERMISSION",
  GET_PERMISSION = "GET_PERMISSION",
}
